import { useDebouncedValue } from "@mantine/hooks"
import { PaginationState } from "@tanstack/react-table"
import { useEffect, useState } from "react"

import { DataFetchWrapper } from "~/components/DataFetchWrapper"
import {
  HeaderControlsProvider,
  useHeaderControlsContext,
} from "~/components/contexts/useHeaderControlsContext"

import { TranslationsAdmin } from "./TranslationsAdmin"
import { useListTranslations } from "./hooks"

const DEFAULT_PAGE_SIZE = 50
const TranslationsAdminWrapperContent = () => {
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: DEFAULT_PAGE_SIZE,
  })

  const { filters } = useHeaderControlsContext()

  const [debouncedSearchParams] = useDebouncedValue<string>(filters.search, 600)

  const query = useListTranslations({
    pagination: {
      page: pagination.pageIndex,
      pageSize: pagination.pageSize,
    },
    searchParams: debouncedSearchParams,
  })

  useEffect(() => {
    setPagination((prev) => ({
      ...prev,
      pageIndex: 0,
    }))
  }, [debouncedSearchParams])

  return (
    <DataFetchWrapper query={query}>
      {({ data, isFetching }) => (
        <TranslationsAdmin
          components={data?.translations ?? []}
          isFetching={isFetching}
          pagination={pagination}
          setPagination={setPagination}
          translationsTotal={data?.total ?? 0}
        />
      )}
    </DataFetchWrapper>
  )
}

export const TranslationsAdminWrapper = () => {
  return (
    <HeaderControlsProvider>
      <TranslationsAdminWrapperContent />
    </HeaderControlsProvider>
  )
}
